<template>
    <b-card>
        <b-card-body>

            <h4 class="mb-4">Edit Conference Information</h4>

            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Conference Title <span class="required">*</span></label>
                        <b-form-input v-model="conference.title"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group>
                        <label>Conference Code <span class="required">*</span></label>
                        <b-form-input v-model="conference.code"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Start Date <span class="required">*</span></label>
                        <b-form-datepicker id="datepicker-placeholder" local="en" v-model="conference.startAt"></b-form-datepicker>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>End Date <span class="required">*</span></label>
                        <b-form-datepicker id="datepicker-placeholder" local="en" v-model="conference.endAt"></b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <label>Description <span class="required">*</span></label>

                    <quill-editor v-model="conference.description" ref="myQuillEditor" :options="editorOption">
                    </quill-editor>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
                <b-col>
                    <label>Information <span class="required">*</span></label>
                    <p class="text-muted">This information is displayed to registrants once they are successfully registered.</p>

                    <quill-editor v-model="conference.information" ref="myQuillEditor" :options="editorOption">
                    </quill-editor>
                </b-col>
            </b-form-row>

            <h5 class="mt-5 mb-4">Payment Information</h5>

            <b-form-row class="mt-3">
                <b-col>
                    <b-form-checkbox class="text-muted" v-model="conference.allowCc" value="true" unchecked-value="false">Accept Credit Card registrations.</b-form-checkbox>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-3">
                <b-col>
                    <b-form-checkbox class="text-muted" v-model="conference.allowPo" value="true" unchecked-value="false">Accept Purchase Order (P.O.) registrations.</b-form-checkbox>
                </b-col>
            </b-form-row>

            <div v-if="conference.allowPo === 'true'" class="mt-5">
                <h5 class="mb-4">Purchase Order (P.O.) Information</h5>

                <b-form-row class="mt-4">
                    <b-col cols="9">
                        <label>Address <span class="required">*</span></label>
                        <b-form-input v-model="conference.poAddress1"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Apt, suite, etc.</label>
                        <b-form-input v-model="conference.poAddress2"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-2">
                    <b-col cols="4">
                        <label>City <span class="required">*</span></label>
                        <b-form-input v-model="conference.poCity"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <label>State <span class="required">*</span></label>
                        <b-form-select v-model="conference.poState">
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </b-form-select>
                    </b-col>
                    <b-col cols="4">
                        <label>Zip <span class="required">*</span></label>
                        <b-form-input v-model="conference.poZip"></b-form-input>
                    </b-col>
                </b-form-row>

            </div>

            <div class="mt-5 mb-5">
                <b-button variant="success" :to="{name: 'organization'}"><i class="fas fa-check-circle mr-3"></i>Save Conference</b-button>
                <b-button class="ml-3">Cancel</b-button>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "conference-details",
        data() {
            return {
                editorOption: {
                    // some quill options
                },
                content: ''
            }
        },
        methods: {
            ...mapActions(['getConferenceById', 'activateReg']),
            activate(reg) {
                reg.po_pending = 'false';
                this.activateReg(reg.code)
            }
        },
        computed: {
            ...mapGetters(['conference'])
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    a {
        color: $success;
    }

    .quill-editor {
        .ql-toolbar {
            border: 1px solid #e5e5e5;
            border-top-left-radius: 0.2rem;
            border-top-right-radius: 0.2rem;
        }

        .ql-container {
            border: 1px solid #e5e5e5;
            border-bottom-left-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;

            max-height: 400px;
            overflow-y: auto;
        }

        p {
            margin-bottom: 1rem;
        }
    }

    .required {
        color: red;
    }
</style>
